import { render } from "./AudioIcon.svg?vue&type=template&id=98c75728"
const script = {}
script.render = render

export default script